<!--<app-select-icon class="board-column-menu__select-icon"></app-select-icon>-->
<div (clickOutside)="onClose.emit()">
  <app-select-color
    (onChangeColor)="onChangeColor($event)"
    [color]="model.color"
    class="board-column-menu__select-color select-color_no-padding"
  >
  </app-select-color>

  <div class="board-column-menu__bottom">
    <button type="button" class="board-column-menu__delete" (click)="onDelete()">
      {{ deleteButtonText() }}
    </button>
  </div>
</div>
